var lib_core = require("lib-core");

var VersionsModel = function (dataRoot, sidebarModel, config) {
    var self = this;
    lib_core.Model.call(this);

    this.dataRoot = dataRoot;
    this.asset = this.value("asset", true);
    this.asset(dataRoot.asset);
    this.busy = this.value("busy",  true);
    this.draftVisible = this.value("draftVisible", true);
    this.sidebarModel = sidebarModel;
    this.config = config;

    if(this.sidebarModel){
        this.sidebarModel.show.onChange("reloadVersionsOnOpen", function(show){
            if(show){
                self.reloadVersions();
            }
        });
    }
};

lib_core.inherit(VersionsModel, lib_core.Model);
VersionsModel.$class = "VersionsModel";

module.exports = VersionsModel;

VersionsModel.prototype.reloadVersions = function() {
    var self = this;
    var assetId = this.dataRoot.header["assetId"];
    var assetType = this.dataRoot.header["assetType"];

    return this.dataRoot.dataLoader.dataManager.getResource(assetType, assetId)
        .then(function(asset) {
            self.asset(asset);
        });
};
